import { render, staticRenderFns } from "./need-solution.vue?vue&type=template&id=6a18b8d4&scoped=true&"
import script from "./need-solution.vue?vue&type=script&lang=js&"
export * from "./need-solution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18b8d4",
  null
  
)

export default component.exports